import styles from "./PopupWrapper.module.css";
export const PopupWrapper = (props) => {
  const { visible, children } = props;


  return (
    <>{visible && <div className={styles.popupWrapper}>{children}</div>}</>
  );
};
